import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";

// import Button from "./common/Button";

import { ArrowLeftIcon } from "@heroicons/react/24/solid";

export default function ModalFull(props) {
  const innerClassName =
    "tw-select-none tw-flex-auto " +
    (props.innerClassName ?? "") +
    (props.scrollable && props.scrollable === true
      ? " tw-overflow-y-auto tw-overscroll-y-contain"
      : "");
  const outerClassName = (props.outerClassName) ? props.outerClassName : '';  
  let isOpen = (typeof props.isOpen === 'object') ? true: props.isOpen;
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="tw-relative tw-z-[1000]"
          onClose={props.closeModal}
        >
          <Transition.Child
            as={Fragment}
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0"
            enterTo="tw-opacity-100"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100"
            leaveTo="tw-opacity-0"
          >
            <div className="tw-fixed tw-inset-0 -tw-top-[var(--pg-header-height)] tw-bg-black tw-bg-opacity-95" />
          </Transition.Child>

          <div className="tw-fixed tw-inset-0  tw-flex tw-items-center tw-justify-center md:tw-p-12">
            <Transition.Child
              as={Fragment}
              enter="tw-ease-out tw-duration-300"
              enterFrom="tw-opacity-0 tw-scale-95"
              enterTo="tw-opacity-100 tw-scale-100"
              leave="tw-ease-in tw-duration-200"
              leaveFrom="tw-opacity-100 tw-scale-100"
              leaveTo="tw-opacity-0 tw-scale-95"
            >
              <Dialog.Panel className={"tw-relative tw-w-full tw-max-w-screen-md tw-h-full tw-bg-white tw-text-black tw-text-left tw-flex tw-flex-col tw-antialiased tw-font-text tw-overflow-hidden md:tw-rounded-xl "+outerClassName}>
                <div className="tw-h-14 tw-flex-none tw-relative tw-flex tw-items-center tw-justify-center tw-border-b tw-border-gray-medium">
                  <Dialog.Title
                    as="h3"
                    className="tw-font-condensed tw-font-black tw-text-2xl tw-uppercase tw-italic tw-text-teal"
                  >
                    {props.title}
                  </Dialog.Title>
                  <button
                    className="tw-absolute tw-left-2 tw-top-2 tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center active:tw-outline-0 focus:tw-outline-0"
                    onClick={props.closeModal}
                  >
                    <ArrowLeftIcon className="tw-w-6 tw-h-6" />
                  </button>
                </div>

                <div className={innerClassName}>{props.children}</div>

                {/* <div className="tw-h-14 tw-px-2 tw-relative tw-flex tw-items-center tw-justify-center tw-border-t tw-border-gray-medium">
                    <Button
                      color="teal"
                      size="medium"
                      type="fill"
                      onClick={props.closeModal}
                      title="Ok"
                      className="tw-w-full"
                    />
                  </div> */}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
